<section id="screenshots" class="text-center">
	<h5 i18n="Screenshots@@meida.screenshot.headline">Screenshots</h5>
	<div class="screenshotGallery">
		<div class="navigationContainer left">
			<div class="arrow arrow-left" (click)="showPrev();" angulartics2On="click" angularticsAction="previousScreenshotButton" angularticsCategory="media"></div>
		</div>
		<gallery id="screenshotLightbox" [nav]="false" [imageSize]="'cover'" [loadingMode]="'indeterminate'" [loadingStrategy]="'lazy'" angulartics2On="click" angularticsAction="openScreenshotButton" angularticsCategory="media"></gallery>
		<div class="navigationContainer right">
			<div class="arrow arrow-right" (click)="showNext();" angulartics2On="click" angularticsAction="previousScreenshotButton" angularticsCategory="media"></div>
		</div>
	</div>

</section>